import { escapeXmlEntities } from "@nova/util-strings"

export interface Point {
    latitude: number
    longitude: number
    altitude?: number
}

const createCoordinate = ({ latitude, longitude, altitude }: Point) => {
    return `${longitude},${latitude},${altitude || 0}`
}

const idGenerator = (flightName: string) => {
    let i = 1
    const time = Date.now().toString(36)

    return () => `${flightName}-flight-path-${i++}-${time}`
}

const createPlacemark =
    (getId: () => string) =>
    ({ latitude, longitude, altitude }: Point) => {
        const id = getId()
        return `
      <Placemark id="${id}">
          <styleUrl>#placemark</styleUrl>
          <description>${latitude} lat, ${longitude} lng</description>
          <Point id="point-${id}">
          <altitudeMode>absolute</altitudeMode>
              <coordinates>${longitude},${latitude},${altitude}</coordinates>
          </Point>
      </Placemark>`
    }

export function createFlightpathKML(name: string, flightpaths: Point[][], showPlacemarks = false) {
    const getId = idGenerator(name)
    const escapedName = escapeXmlEntities(name)
    return `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <name>${escapedName}</name>
    <Style id="bluePoly">
      <LineStyle>
        <color>FFA96D1E</color>
        <width>2</width>
      </LineStyle>
    </Style>
    <Style id="placemark">
      <IconStyle>
        <scale>0.3</scale>
      </IconStyle>
    </Style>
    ${flightpaths.map((flightpath) => {
        flightpath = flightpath.filter((e) => e.longitude && e.latitude)
        return `<Placemark>
      <name>${escapedName}</name>
      <styleUrl>#bluePoly</styleUrl>
      <LineString>
        <altitudeMode>relativeToGround</altitudeMode>
        <coordinates> ${flightpath.map(createCoordinate).join("\n")}
        </coordinates>
      </LineString>
    </Placemark>
    ${showPlacemarks ? flightpath.map(createPlacemark(getId)).join("\n") : ""}`
    })}
  </Document>
</kml>`
}
